<template>
  <div class="org-item" @click="linkPackageV1(item)">
    <img
      class="profile"
      :src="cos_prefix + item.p_img_small"
      :onerror="defaultLogo"
    />
    <div class="item-content">
      <p class="org-name">
        <i v-if="item.org_tag" class="rating">{{ item.org_tag }}</i
        >{{ item.name }}
      </p>
      <div class="label">
        <!-- <Tag v-for="(org_tags_item, index) in item.org_tags" :content="org_tags_item" :key="index"/> -->
        <Tag :content="item.package_item_count + '项检查'" :isActive="true" />
      </div>
      <div class="package">
        <div class="price-wrapper">
          <span class="price">{{ item.min_price / 100 }}</span>
          <span>元{{ item.org_supplier_cnt > 1 ? "/起" : "" }}</span>
        </div>
        <!-- <span>已售{{ item.sold_cnt }}</span> -->
      </div>
      <hr size="0.01rem" color="#E8E8E8" />
      <p class="address-wrapper">
        <span class="address">{{ item.org_name }}</span>
        <span v-if="item.distance" class="distance"
          >{{ item.distance | filterDistance }}km</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import Tag from "@/components/common/Tag";
import TitleGroup from "@/components/index/TitleGroup";
import ScoreModule from "@/components/common/ScoreModule";
import { packageMixin } from "@/mixins";

export default {
  name: "PackageCard",
  components: {
    TitleGroup,
    ScoreModule,
    Tag,
  },
  mixins: [packageMixin],
  props: {
    // 板块标题
    item: {
      type: Object,
    },
  },
  data() {
    return {
      defaultLogo: `this.src="${brandConfig.defaultOrgImg}"`,
      defaultList: [{}, {}, {}, {}, {}],
      cos_prefix,
    };
  },
  filters: {
    filterDistance(distance) {
      if (distance < 1) {
        return "<1";
      } else if (distance > 50) {
        return ">50";
      }
      return distance;
    },
  },
  methods: {
    linkPackageV1(item) {
      let data = item;
      data.discount = this.$route.query.discount
        ? this.$route.query.discount
        : "";
      data.coupon_id = this.$route.query.coupon_id
        ? this.$route.query.coupon_id
        : "";
      data.isGroup = !!this.group_buy_list;
      this.linkPackage(data);
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~@/assets/css/mixin.less");

.org-item {
  width: 100%;
  background: #ffffff;
  border-radius: 20/200rem;
  padding: 30/200rem 30/200rem 20/200rem;
  margin-top: 24/200rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  .profile {
    width: 140/200rem;
    height: 140/200rem;
    object-fit: cover;
    border-radius: 16/200rem;
  }

  .item-content {
    flex: 1;
    height: 100%;
    margin-left: 24/200rem;

    .org-name {
      display: block;
      width: 100%;
      font-size: 32/200rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 48/200rem;
      .ellipsis-line(100% , 2);
      margin-bottom: 16/200rem;
      span {
        display: inline-block;
      }
      .rating {
        margin: -4/200rem 10/200rem 0 0;
        padding: 6/200rem 4/200rem 6/200rem 6/200rem;
        font-size: 20/200rem;
        vertical-align: middle;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20/200rem;
        background: linear-gradient(90deg, #14d3a6 0%, #14cfa2 100%);
        border-radius: 4/200rem;
      }
    }

    .label {
      margin-bottom: 20/200rem;
    }

    .package {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .price-wrapper {
        display: flex;
        align-items: flex-end;
        font-size: 22/200rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: @color-bg-r;
        line-height: 24/200rem;
        .price {
          font-size: 32/200rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 32/200rem;
          margin-right: 8/200rem;
        }
      }
    }
    hr {
      margin: 20/200rem 0;
      transform: scaleY(0.5);
    }
    .address-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 22/200rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #85898c;
      .address {
        .ellipsis-line(100% , 1);
      }
      .distance {
        margin-left: 64/200rem;
      }
    }
  }
}
</style>
